
<!-- 顶部组件 -->
<template>
  <div class="header">
    <div class="index-header flex_col_between" :style="{backgroundImage: 'url('+ topBgimg +')'}">
      <div class="header-top">
        <div class="flex_rowL">
          <div class="header-top-logo">
            <img src="@/assets/new_index_logo1.png" alt="">
          </div>
          <div class="header-top-tag"></div>
          <div class="header-top-tabs">
            <ul class="flex_rowL">
              <li class="cursorPointer" @click="backHome">首页</li>
              <el-popover
                placement="bottom"
                width="110"
                trigger="hover"
                v-model="visible">
                <div class="header-popover">
                  <div class="cursorPointer textC"
                       @click="toPage(index)"
                       v-for="(item,index) in tabsList" :key="index">
                    {{item}}
                  </div>
                </div>
                <div slot="reference" class="cursorPointer " @click="visible=!visible">
                  <li class="cursorPointer">
                    <span>产品与服务</span>
                    <span class="el-icon-arrow-down" v-show="visible"></span>
                    <span class="el-icon-arrow-up" v-show="!visible"></span>
                  </li>
                </div>
              </el-popover>
              <li class="cursorPointer">关于我们</li>
              <li class="cursorPointer">联系我们</li>
            </ul>
          </div>
        </div>
        <div class="flex_rowR">
          <button class="btn1 fontSize_14 login_btn" @click="$parent.toLogin(1)">企业招聘端登录</button>
          <button class="btn1 fontSize_14 login_btn" @click="$parent.toLogin(2)">人才推荐官登录</button>
          <button class="btn2 fontSize_14" @click="$parent.dialogTableVisible1 = !$parent.dialogTableVisible1">免费试用</button>
        </div>
      </div>
      <div class="header-main relative flex_grow_1 flex_row_between">
        <div>
          <template v-if="descType == 'index'">
            <div class="header-main-title1">
              萝卜猎手，帮助企业招人不再碰运气
            </div>
            <div class="header-main-title2">
              企业人力资源雇前一站式服务平台
            </div>
            <div class="header-main-title3">
              精准招人 &nbsp; 丨 &nbsp;背景调查&nbsp; 丨 &nbsp;风险控制&nbsp; 丨 &nbsp;高效用人
            </div>
          </template>
          <template v-else-if="descType == 'backdropInquiry'">
            <div class="header-main-title1">
              专业的智能化背景调查平台
            </div>
            <div class="header-main-title2">
              还原真实履历，构筑诚信职场
            </div>
            <div class="header-main-title3">
              帮企业远离99种用工风险
            </div>
          </template>
          <div class="header-main-btn">
            <button class="btn1 fontSize_14" @click="$parent.dialogTableVisible1 = !$parent.dialogTableVisible1">立即免费试用</button>
            <button class="btn2 fontSize_14" @click="$parent.toRegister">立即注册</button>
          </div>
        </div>
        <img style="height: 400px;right: -70px" v-if="topImgShow" class="absolute" src="@/assets/index_top_img.png" alt="">
      </div>

    </div>
  </div>
</template>

<script>
  import '@/common/css/index.css'

  export default {
    props:['topBgimg','topImgShow','descType'],
    data() {
      return {
        visible:false,
        // tabsList:['背景调查','简历公海','招聘保险','职业档案']
        tabsList:['背景调查']
      }
    },
    created() {

    },
    mounted() {
      console.log(3333333, this.$parent);
    },
    methods: {
      // 返回首页
      backHome() {
        this.$router.push('/')
      },
      // 页面跳转
      toPage(index) {
        switch (index) {
          case 0 :
            this.$router.push('/backdropInquiry');
            break;
          case 1 :

            break;
          case 2 :

            break;
          case 3 :

            break;
        }
      },
    },
    computed: {},
  }
</script>

<style scoped>
  .header-popover {
    padding: 10px 0;
  }
  .header-popover div {
    padding: 10px 0;
  }
  .header-popover div:hover {
    background: #FFEBDC;
    color: #FE5903;
  }
.el-popover {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/headerTop.vue